var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticStyle:{"margin-top":"30px","padding":"0 15px"},style:({ fontSize: _vm.calculateFontSize,'text-align': _vm.$route.path === '/workspace' ? 'center' : '' })},[_vm._v(" "+_vm._s(_vm.titleToShow)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }